var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.12,
    height: 10.12,
    viewBox: "0 0 10.12 10.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M8.792.071.574,3.864A.958.958,0,0,0,.954,5.7H4.431V9.174a.958.958,0,0,0,1.833.379l3.793-8.218A.986.986,0,0,0,8.792.071Z",
    transform: "translate(-0.007 -0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDirection);
export default __webpack_public_path__ + "static/media/icon-direction.bdd4185ae08c7204a43866d2e094a572.svg";
export { ForwardRef as ReactComponent };